import { GradeMaterials } from 'src/app/shared/models/grade-materials.model';

export const GRADES_11_12_MATERIALS: GradeMaterials = {
  categories: [
    {
      headingEn: 'Introductory items',
      headingEs: 'Elementos introductorios',
      items: [
        {
          id: 'program-guide-11-12',
          labelEn: 'Program Guide 11—12',
          labelEs: 'Guía del programa 11—12',
          subLabelEn: 'website\'s program section',
          subLabelEs: 'sección del programa de la página de web',
          filePath: 'assets/printables/en/11-12/Program_Guide_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Program_Guide_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'letter-parents-11-12',
          labelEn: 'Letter to parents',
          labelEs: 'Carta para los padres',
          filePath: 'assets/printables/en/11-12/Letter_Parents_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Letter_Parents_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'letter-administrator-11-12',
          labelEn: 'Letter to administrator',
          labelEs: 'Carta para los administradores',
          filePath: 'assets/printables/en/11-12/Letter_Administrator_11-12.docx',
          filePathEs: 'assets/printables/es/11-12/Letter_Administrator_11-12_ES.docx',
          iconType: 'doc'
        },
        {
          id: 'letter-donation-11-12',
          labelEn: 'Donation request letter',
          labelEs: 'Carta de solicitud para donaciones',
          filePath: 'assets/printables/en/11-12/Letter_Donation_Request_11-12.docx',
          filePathEs: 'assets/printables/es/11-12/Letter_Donation_Request_11-12_ES.docx',
          iconType: 'doc'
        }
      ]
    },
    {
      headingEn: 'Employment',
      headingEs: 'Empleo',
      items: [
        {
          id: 'payday-video-11-12',
          labelEn: 'Payday video',
          labelEs: 'Video sobre el día de pago',
          filePath: 'assets/video/CE_S01.mp4',
          filePathEs: 'assets/video/CE_S01.mp4',
          iconType: 'video'
        },
        {
          id: 'job-application-11-12',
          labelEn: 'Job application',
          labelEs: 'Aplicación de trabajo',
          filePath: 'assets/printables/en/11-12/Job_Application_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Job_Application_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'job-offer-11-12',
          labelEn: 'Job offer',
          labelEs: 'Oferta de trabajo',
          filePath: 'assets/printables/en/11-12/Job_Offer_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Job_Offer_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'job-posters-11-12',
          labelEn: 'Job posters',
          labelEs: 'Afiches de trabajo',
          filePath: 'assets/printables/en/11-12/Job_Posters_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Job_Posters_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'paycheck-11-12',
          labelEn: 'Paychecks',
          labelEs: 'Sueldo',
          filePath: 'assets/printables/en/11-12/Paycheck_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Paycheck_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'business-license-11-12',
          labelEn: 'Business license',
          labelEs: 'Licencia de negocios',
          filePath: 'assets/printables/en/11-12/Business_License_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Business_License_11-12_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Banking',
      headingEs: 'Bancario/a',
      items: [
        {
          id: 'bank-slip-11-12',
          labelEn: 'Bank slips',
          labelEs: 'Recibos bancarios',
          filePath: 'assets/printables/en/11-12/Bank_Slip_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Bank_Slip_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bank-log-11-12',
          labelEn: 'Classroom bank log',
          labelEs: 'El registro de banco para la clase',
          filePath: 'assets/printables/en/11-12/Bank_Log_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Bank_Log_11-12_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Fines',
      headingEs: 'Multas',
      items: [
        {
          id: 'fine-ticket-11-12',
          labelEn: 'Fine tickets',
          labelEs: 'Tiquetes de multa',
          filePath: 'assets/printables/en/11-12/Fine_Ticket_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Fine_Ticket_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'offense-log-11-12',
          labelEn: 'Offense log',
          labelEs: 'Registro de ofensas',
          filePath: 'assets/printables/en/11-12/Offense_Log_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Offense_Log_11-12_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Cash',
      headingEs: 'Dinero',
      items: [
        {
          id: 'bills-50-11-12',
          labelEn: '$50 bills',
          labelEs: 'Billetes de $50',
          subLabelEn: 'small bills: see grades 2—3',
          subLabelEs: 'facturas pequeñas: refiera los grados 2-3',
          filePath: 'assets/printables/en/11-12/Bills_50_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Bills_50_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bills-100-11-12',
          labelEn: '$100 bills',
          labelEs: 'Billetes de $100',
          filePath: 'assets/printables/en/11-12/Bills_100_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Bills_100_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bills-500-11-12',
          labelEn: '$500 bills',
          labelEs: 'Billetes de $500',
          filePath: 'assets/printables/en/11-12/Bills_500_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Bills_500_11-12_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Rent & deeds',
      headingEs: 'Alquiler y título de propiedad',
      items: [
        {
          id: 'rental-agreement-11-12',
          labelEn: 'Rental agreement',
          labelEs: 'Contrato de alquiler',
          filePath: 'assets/printables/en/11-12/Rental_Agreement_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Rental_Agreement_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'rent-log-11-12',
          labelEn: 'Rent log',
          labelEs: 'Registro de alquiler',
          filePath: 'assets/printables/en/11-12/Rent_Log_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Rent_Log_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'unpaid-rent-notice-11-12',
          labelEn: 'Unpaid rent notice',
          labelEs: 'Aviso de renta no pagada',
          filePath: 'assets/printables/en/11-12/Unpaid_Rent_Notice_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Unpaid_Rent_Notice_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'desk-deed-11-12',
          labelEn: 'Deed to desk',
          labelEs: 'Título de propiedad del escritorio',
          filePath: 'assets/printables/en/11-12/Desk_Deed_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Desk_Deed_11-12_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Bills & taxes',
      headingEs: 'Cuentas e impuestos',
      items: [
        {
          id: 'bill-pay-log-11-12',
          labelEn: 'Classroom bill pay log',
          labelEs: 'Registro de cuentas pagadas de la clase',
          filePath: 'assets/printables/en/11-12/Bill_Pay_Log_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Bill_Pay_Log_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'energy-log-11-12',
          labelEn: 'Classroom energy log',
          labelEs: 'Registro de energía de la clase',
          filePath: 'assets/printables/en/11-12/Energy_Log_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Energy_Log_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'tax-record-11-12',
          labelEn: 'Tax record form',
          labelEs: 'Documento de registro de impuestos',
          filePath: 'assets/printables/en/11-12/Tax_Record_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Tax_Record_11-12_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Auctions',
      headingEs: 'Subastas',
      items: [
        {
          id: 'auction-video-11-12',
          labelEn: 'Auction video',
          labelEs: 'Video sobre subastas',
          filePath: 'assets/video/CE_S04.mp4',
          filePathEs: 'assets/video/CE_S04.mp4',
          iconType: 'video'
        },
        {
          id: 'auction-record-11-12',
          labelEn: 'Auction record form',
          labelEs: 'Forma de registro de subasta',
          filePath: 'assets/printables/en/11-12/Auction_Record_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Auction_Record_11-12_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'auction-paddle-11-12',
          labelEn: 'Auction paddle',
          labelEs: 'Paleta de subastas',
          filePath: 'assets/printables/en/11-12/Auction_Paddle_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Auction_Paddle_11-12_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Year-end certificates',
      headingEs: 'Certificados de fin de año',
      items: [
        {
          id: 'saver-certs-11-12',
          labelEn: 'Saver certificates (Includes Saver, Super, and Ultimate awards)',
          labelEs: 'Certificado de ahorro (Incluye los premios Saver, Super y Ultimate)',
          filePath: 'assets/printables/en/11-12/Saver_Certs_11-12.pdf',
          filePathEs: 'assets/printables/es/11-12/Saver_Certs_11-12_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Posters & handouts',
      headingEs: 'Afiches y folletos',
      items: [
        {
          id: 'bonus-list-11-12',
          labelEn: 'Bonus list',
          labelEs: 'Lista de bonificaciones',
          filePath: 'assets/printables/en/11-12/Bonus_List_11-12.docx',
          filePathEs: 'assets/printables/es/11-12/Bonus_List_11-12_ES.doc',
          iconType: 'doc'
        },
        {
          id: 'fine-list-11-12',
          labelEn: 'Fine list',
          labelEs: 'Lista de multas',
          filePath: 'assets/printables/en/11-12/Fine_List_11-12.docx',
          filePathEs: 'assets/printables/es/11-12/Fine_List_11-12_ES.doc',
          iconType: 'doc'
        }
      ]
    }
  ],
  supplies: {
    headingEn: 'Supplies to have on hand',
    headingEs: 'Suministros para tener al alcance',
    items: [
      { labelEn: 'Envelopes', labelEs: 'Sobres' },
      { labelEn: 'Portfolio folders', labelEs: 'Carpetas de portafolios' },
      { labelEn: 'Cash drawer or box', labelEs: 'Caja de dinero' },
      { labelEn: 'Popsicle sticks for auction paddles', labelEs: 'Palos de paleta para las paletas de subasta' },
      { labelEn: 'Sticky notes', labelEs: 'Notas adhesivas' },
      { labelEn: 'Clipboard', labelEs: 'Portapapeles' },
      { labelEn: 'Auction items', labelEs: 'Artículos de subasta' }
    ]
  }
};
